import { createEvent, createStore } from 'effector';

export const atualizaInputRef = createEvent<React.MutableRefObject<HTMLInputElement | null>>();

export const $inputSearchRef = createStore<React.MutableRefObject<HTMLInputElement | null>>({
  current: null,
}).on(atualizaInputRef, (_, value) => value);
